module.exports = __webpack_public_path__ + "img/img-redtiger.058b673e.png";